// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3k-0";
export var eligibilityCardNotEligible = "_3k-1";